<!-- Main Body Starts -->
<div class="layout-px-spacing">
  <div class="row" style="width: 100%">
    <!-- QUICK CATEGORIES -->
    <div class="row quick-categories-container">
      <div class="security-breaches">
        <a class="widget quick-category" style="cursor: default">
          <div class="quick-category-head">
            <span class="rounded-circle">
              <i class="icon dashboard-breaches" style="font-size: 30px"></i>
            </span>
            <span class="rounded-circle">
              <div
                data-tooltip="securityBreaches"
                class="tooltip-container"
                (click)="toggleTooltip('securityBreaches')"
              >
                <i
                  class="icon dashboard-tooltip-info"
                  style="font-size: 30px"
                ></i>
                <span
                  *ngIf="tooltipsVisible['securityBreaches']"
                  (click)="$event.stopPropagation()"
                  class="tooltip-content"
                  >{{ 'home.securityBreachesTooltip' | translate }}</span
                >
              </div>
            </span>
          </div>
          <div class="quick-category-content">
            <div
              *ngIf="loadingSecurityBreachesCount"
              style="margin-bottom: 0.8rem"
              class="spinner-border"
              role="status"
            >
              <span class="sr-only"></span>
            </div>
            <h3 *ngIf="!loadingSecurityBreachesCount">
              {{ securityBreachesCount || 0 }}
            </h3>
            <p class="font-17 text-primary mb-0">
              {{ 'home.securityBreaches' | translate }}
            </p>
          </div>
        </a>
      </div>
      <div class="labeled-documents">
        <a class="widget quick-category" style="cursor: default">
          <div class="quick-category-head">
            <span class="rounded-circle">
              <i class="icon dashboard-docs" style="font-size: 30px"></i>
            </span>
            <span class="rounded-circle">
              <div
                data-tooltip="labeledDocuments"
                class="tooltip-container"
                (click)="toggleTooltip('labeledDocuments')"
              >
                <i
                  class="icon dashboard-tooltip-info"
                  style="font-size: 30px"
                ></i>
                <span
                  *ngIf="tooltipsVisible['labeledDocuments']"
                  (click)="$event.stopPropagation()"
                  class="tooltip-content"
                  >{{ 'home.labeledDocumentsTooltip' | translate }}</span
                >
              </div>
            </span>
          </div>
          <div class="quick-category-content">
            <div
              *ngIf="loadingDocumentLabeledCount"
              style="margin-bottom: 0.8rem"
              class="spinner-border"
              role="status"
            >
              <span class="sr-only"></span>
            </div>
            <h3 *ngIf="!loadingDocumentLabeledCount">
              {{ documentLabeledCount || 0 }}
            </h3>
            <p style="color: #2f44b2" class="font-17 mb-0">
              {{ 'home.labeledDocuments' | translate }}
            </p>
          </div>
        </a>
      </div>
      <div class="identified-alerts">
        <a class="widget quick-category" style="cursor: default">
          <div class="quick-category-head">
            <span class="rounded-circle">
              <i class="icon dashboard-alertas" style="font-size: 20px"></i>
            </span>
            <span class="rounded-circle">
              <div
                data-tooltip="identifiedAlerts"
                class="tooltip-container"
                (click)="toggleTooltip('identifiedAlerts')"
              >
                <i
                  class="icon dashboard-tooltip-info"
                  style="font-size: 30px"
                ></i>
                <span
                  *ngIf="tooltipsVisible['identifiedAlerts']"
                  (click)="$event.stopPropagation()"
                  class="tooltip-content"
                  >{{ 'home.identifiedAlertsTooltip' | translate }}</span
                >
              </div>
            </span>
          </div>
          <div class="quick-category-content">
            <div
              *ngIf="loadingIdentifiedAlertsCount"
              style="margin-bottom: 0.8rem"
              class="spinner-border"
              role="status"
            >
              <span class="sr-only"></span>
            </div>
            <h3 *ngIf="!loadingIdentifiedAlertsCount">
              {{ identifiedAlertsCount || 0 }}
            </h3>
            <p class="font-17 text-warning mb-0">
              {{ 'home.identifiedAlerts' | translate }}
            </p>
          </div>
        </a>
      </div>
      <div class="users-tagging">
        <a class="widget quick-category" style="cursor: default">
          <div class="quick-category-head">
            <span class="rounded-circle">
              <i class="icon dashboard-usuarios" style="font-size: 30px"></i>
            </span>
            <span class="rounded-circle">
              <div
                data-tooltip="usersTagging"
                class="tooltip-container"
                (click)="toggleTooltip('usersTagging')"
              >
                <i
                  class="icon dashboard-tooltip-info"
                  style="font-size: 30px"
                ></i>
                <span
                  *ngIf="tooltipsVisible['usersTagging']"
                  (click)="$event.stopPropagation()"
                  class="tooltip-content"
                  >{{ 'home.usersTaggingTooltip' | translate }}</span
                >
              </div>
            </span>
          </div>
          <div class="quick-category-content">
            <div
              *ngIf="loadingTaggingUsersCount"
              style="margin-bottom: 0.8rem"
              class="spinner-border"
              role="status"
            >
              <span class="sr-only"></span>
            </div>
            <h3 *ngIf="!loadingTaggingUsersCount">
              {{ taggingUsersCount || 0 }}
            </h3>
            <p style="color: #5c1ac3" class="font-17 mb-0">
              {{ 'home.usersTagging' | translate }}
            </p>
            <span *ngIf="isExceeded" style="color: red" class="text-center">{{
              'home.contractedLicenseExceeded' | translate
            }}</span>
          </div>
        </a>
      </div>
      <div class="copilot-interactions">
        <a class="widget quick-category" style="cursor: default">
          <div class="quick-category-head">
            <span class="rounded-circle">
              <i class="icon dashboard-breaches" style="font-size: 30px"></i>
            </span>
            <span class="rounded-circle">
              <div
                data-tooltip="copilotInteractions"
                class="tooltip-container"
                (click)="toggleTooltip('copilotInteractions')"
              >
                <i
                  class="icon dashboard-tooltip-info"
                  style="font-size: 30px"
                ></i>
                <span
                  *ngIf="tooltipsVisible['copilotInteractions']"
                  (click)="$event.stopPropagation()"
                  class="tooltip-content"
                  >{{ 'home.copilotInteractionsTooltip' | translate }}</span
                >
              </div>
            </span>
          </div>
          <div class="quick-category-content">
            <div
              *ngIf="loadingCopilotInteractionsCount"
              style="margin-bottom: 0.8rem"
              class="spinner-border"
              role="status"
            >
              <span class="sr-only"></span>
            </div>
            <h3 *ngIf="!loadingCopilotInteractionsCount">
              {{ copilotInteractionsCount || 0 }}
            </h3>
            <p style="color: #5c1ac3" class="font-17 mb-0">
              {{ 'home.copilotInteractions' | translate }}
            </p>
            <span *ngIf="isExceeded" style="color: red" class="text-center">{{
              'home.contractedLicenseExceeded' | translate
            }}</span>
          </div>
        </a>
      </div>
    </div>
    <!-- CHARTS -->
    <div class="charts-container">
      <div class="chart-one">
        <div class="widget widget-chart-one">
          <div class="widget-heading">
            <h5 class="">{{ 'home.actionAlertsSentitiveData' | translate }}</h5>
            <span class="rounded-circle">
              <div
                data-tooltip="actionAlertsSentitiveData"
                class="tooltip-container"
                (click)="toggleTooltip('actionAlertsSentitiveData')"
              >
                <i
                  class="icon dashboard-tooltip-info"
                  style="font-size: 30px"
                ></i>
                <span
                  *ngIf="tooltipsVisible['actionAlertsSentitiveData']"
                  (click)="$event.stopPropagation()"
                  class="tooltip-content bottom"
                  >{{
                    'home.actionAlertsSentitiveDataTooltip' | translate
                  }}</span
                >
              </div>
            </span>
          </div>
          <div class="widget-content" style="min-height: 320px">
            <div class="tabs tab-content">
              <div id="content_1" class="tabcontent">
                <div
                  class="center"
                  style="min-height: 320px"
                  *ngIf="isLoading1"
                >
                  <div class="spinner-border" role="status">
                    <span class="sr-only">{{
                      'home.loading' | translate
                    }}</span>
                  </div>
                </div>
                <div id="transactionsMonthly"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="chart-two">
        <div
          class="widget widget-table-one"
          style="height: fit-content; min-height: 435px"
        >
          <div
            class="widget-heading d-flex justify-content-between align-items-center"
          >
            <h5 class="">{{ 'home.alertsHighSentitiveData' | translate }}</h5>
            <span class="rounded-circle">
              <div
                data-tooltip="alertsHighSentitiveData"
                class="tooltip-container"
                (click)="toggleTooltip('alertsHighSentitiveData')"
              >
                <i
                  class="icon dashboard-tooltip-info"
                  style="font-size: 30px"
                ></i>
                <span
                  *ngIf="tooltipsVisible['alertsHighSentitiveData']"
                  (click)="$event.stopPropagation()"
                  class="tooltip-content bottom"
                  style="width: 29rem"
                  >{{ 'home.alertsHighSentitiveDataTooltip' | translate }}</span
                >
              </div>
            </span>
          </div>
          <div
            class="widget-content"
            style="min-height: 15rem; height: 87% !important"
          >
            <div class="center" style="min-height: 15rem" *ngIf="isLoading4">
              <div class="spinner-border" role="status">
                <span class="sr-only">{{ 'home.loading' | translate }}</span>
              </div>
            </div>
            <div *ngIf="!isLoading4 && !chart4Empty">
              <div
                class="weekly-bestsellers"
                style="cursor: default"
                *ngFor="let alert of sensitiveInformationAlerts"
              >
                <div class="t-item">
                  <div class="t-company-name" style="width: 100%">
                    <div class="t-name" style="width: 100%">
                      <p class="meta-date" style="color: #607eff">
                        {{ alert.sensitiveType || '' }}
                      </p>
                      <h4 style="overflow-wrap: break-word">
                        {{ alert.user || '' }}
                      </h4>
                      <p style="overflow-wrap: break-word" class="meta-date">
                        {{ cutString(alert.file) || '' }}
                      </p>
                    </div>
                  </div>
                  <div class="t-rate rate-inc">
                    <p>
                      <span>{{ alert.count || 0 }}</span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div
              *ngIf="chart4Empty"
              id="noData"
              style="height: 15rem; display: grid; place-content: center"
            >
              {{ 'noData' | translate }}
            </div>
            <a
              *ngIf="!chart4Empty && !isLoading4"
              class="btn btn-block btn-primary"
              routerLink="/home/informes/dlp"
              style="margin-top: 15px"
              >{{ 'home.viewAll' | translate }}</a
            >
          </div>
        </div>
      </div>
      <div class="chart-three">
        <div class="widget dashboard-table" style="height: 445px">
          <div class="widget-heading mb-1">
            <h5 class="">{{ 'home.userLabeling' | translate }}</h5>
            <span class="rounded-circle">
              <div
                data-tooltip="userLabeling"
                class="tooltip-container"
                (click)="toggleTooltip('userLabeling')"
              >
                <i
                  class="icon dashboard-tooltip-info"
                  style="font-size: 30px"
                ></i>
                <span
                  *ngIf="tooltipsVisible['userLabeling']"
                  (click)="$event.stopPropagation()"
                  class="tooltip-content"
                  >{{ 'home.userLabelingTooltip' | translate }}</span
                >
              </div>
            </span>
          </div>
          <div class="widget-content h-100">
            <div
              class="table-responsive"
              style="
                height: 90%;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
              "
            >
              <div class="d-flex justify-content-center" *ngIf="isLoading3">
                <div class="spinner-border" role="status">
                  <span class="sr-only">{{ 'home.loading' | translate }}</span>
                </div>
              </div>
              <table
                *ngIf="!isLoading3 && !chart3Empty"
                class="table table-hover"
              >
                <thead>
                  <tr>
                    <th>
                      <div class="th-content">
                        {{ 'home.user' | translate }}
                      </div>
                    </th>
                    <th>
                      <div class="th-content">
                        {{ 'home.labeled' | translate }}
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let user of topDeniedUsers">
                    <td>
                      <div class="d-flex align-center">
                        <p class="mb-0">{{ user.name || '' }}</p>
                      </div>
                    </td>
                    <td>
                      <span class="text-warning">{{ user.count || 0 }}</span>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div
                *ngIf="chart3Empty"
                id="noData"
                style="height: 4rem; display: grid; place-content: center"
              >
                {{ 'noData' | translate }}
              </div>
              <p
                *ngIf="!isLoading3 && !chart3Empty"
                class="font-13 text-center mt-2 mb-1 text-muted"
              >
                <a class="text-primary" routerLink="/home/informes/irm">{{
                  'home.clickHere' | translate
                }}</a>
                {{ 'home.toSeeFullList' | translate }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="chart-four">
        <div class="widget widget-chart-two">
          <div
            class="widget-heading d-flex justify-content-between align-items-center"
          >
            <h5 class="">{{ 'home.documentLabeling' | translate }}</h5>
            <span class="rounded-circle">
              <div
                data-tooltip="documentLabeling"
                class="tooltip-container"
                (click)="toggleTooltip('documentLabeling')"
              >
                <i
                  class="icon dashboard-tooltip-info"
                  style="font-size: 30px"
                ></i>
                <span
                  *ngIf="tooltipsVisible['documentLabeling']"
                  (click)="$event.stopPropagation()"
                  class="tooltip-content bottom"
                  >{{ 'home.documentLabelingTooltip' | translate }}</span
                >
              </div>
            </span>
          </div>
          <div
            class="widget-content"
            style="min-height: 340px; padding: 0 !important"
          >
            <div class="center" style="min-height: 340px" *ngIf="isLoading2">
              <div class="spinner-border" role="status">
                <span class="sr-only">{{ 'home.loading' | translate }}</span>
              </div>
            </div>
            <div id="orderStatus" class=""></div>
          </div>
        </div>
      </div>
      <div class="chart-five" style="width: 157.3%">
        <div class="widget widget-best-seller">
          <div class="widget-heading mb-1">
            <h5>{{ 'home.labelingChampion' | translate }}</h5>
            <span class="w-numeric-title">{{
              taggingChampion?.user ? taggingChampion.user : ''
            }}</span>
          </div>
          <div class="bs-content row" *ngIf="showChart5">
            <div class="col-md-6">
              <img src="assets/img/trophy.png" class="best-seller-trophy" />
            </div>
            <div class="col-md-6 text-right">
              <h2 class="mb-0">
                {{ taggingChampion?.count ? taggingChampion.count : 0 }}
              </h2>
              <p class="mb-2">{{ 'home.protectedDocuments' | translate }}</p>
              <a
                class="btn btn-primary btn-sm"
                routerLink="/home/informes/irm"
                >{{ 'home.viewAll' | translate }}</a
              >
            </div>
          </div>
          <div
            *ngIf="chart5Empty"
            id="noData"
            style="height: 4rem; display: grid; place-content: center"
          >
            {{ 'noData' | translate }}
          </div>
        </div>
      </div>

      <div class="chart-six">
        <div class="widget widget-chart-one">
          <div class="widget-heading">
            <h5 class="">{{ 'home.topLabelsByDept' | translate }}</h5>
            <span class="rounded-circle">
              <div
                data-tooltip="topLabelsByDeptTooltip"
                class="tooltip-container"
                (click)="toggleTooltip('topLabelsByDeptTooltip')"
              >
                <i
                  class="icon dashboard-tooltip-info"
                  style="font-size: 30px"
                ></i>
                <span
                  *ngIf="tooltipsVisible['topLabelsByDeptTooltip']"
                  (click)="$event.stopPropagation()"
                  class="tooltip-content bottom"
                  >{{ 'home.topLabelsByDeptTooltip' | translate }}</span
                >
              </div>
            </span>
          </div>
          <div class="widget-content" style="min-height: 350px">
            <div class="tabs tab-content">
              <div id="content_1" class="tabcontent">
                <div
                  class="center"
                  style="min-height: 350px"
                  *ngIf="isLoading6"
                >
                  <div class="spinner-border" role="status">
                    <span class="sr-only">{{
                      'home.loading' | translate
                    }}</span>
                  </div>
                </div>
                <div id="labelsByDept"></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="chart-seven">
        <div class="widget widget-three">
          <div
            class="widget-heading d-flex justify-content-between align-items-center"
          >
            <h5 class="">
              {{ 'home.documentLabelingPerDepartment' | translate }}
            </h5>
            <span class="rounded-circle">
              <div
                data-tooltip="documentLabelingPerDepartment"
                class="tooltip-container"
                (click)="toggleTooltip('documentLabelingPerDepartment')"
              >
                <i
                  class="icon dashboard-tooltip-info"
                  style="font-size: 30px"
                ></i>
                <span
                  *ngIf="tooltipsVisible['documentLabelingPerDepartment']"
                  (click)="$event.stopPropagation()"
                  class="tooltip-content bottom"
                  >{{
                    'home.documentLabelingPerDepartmentTooltip' | translate
                  }}</span
                >
              </div>
            </span>
          </div>
          <div class="widget-content" style="min-height: 350px">
            <div class="customer-issues">
              <div class="center" style="min-height: 350px" *ngIf="isLoading5">
                <div class="spinner-border" role="status">
                  <span class="sr-only">{{ 'home.loading' | translate }}</span>
                </div>
              </div>
              <div *ngIf="!isLoading5 && !chart7Empty">
                <div
                  *ngFor="let department of departamentLabel; let i = index"
                  class="customer-issue-list"
                >
                  <div class="customer-issue-details">
                    <div class="customer-issues-info">
                      <h6
                        class="mb-2 font-12"
                        [ngClass]="getIssueClass(department.department)"
                      >
                        {{ department.department }}
                      </h6>
                      <p class="issues-count mb-2 font-12">
                        {{ department.count || 0 }}
                      </p>
                    </div>
                    <div class="customer-issues-stats">
                      <div class="progress">
                        <div
                          class="progress-bar dynamic-color-{{
                            i
                          }} position-relative"
                          [ngStyle]="{
                            width: calculateWidth(department.count, i)
                          }"
                          [ngClass]="getProgressBarClass(i)"
                        >
                          <span [ngClass]="getSpanClass(i)"></span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                *ngIf="chart7Empty && !isLoading5"
                id="noData"
                style="
                  width: 100%;
                  height: 350px;
                  display: grid;
                  place-content: center;
                "
              >
                {{ 'noData' | translate }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="chart-eight">
        <div class="widget dashboard-table" style="height: 445px">
          <div class="widget-heading mb-1">
            <h5 class="">{{ 'home.getTopCopilotUsers' | translate }}</h5>
            <span class="rounded-circle">
              <div
                data-tooltip="getTopCopilotUsers"
                class="tooltip-container"
                (click)="toggleTooltip('getTopCopilotUsers')"
              >
                <i
                  class="icon dashboard-tooltip-info"
                  style="font-size: 30px"
                ></i>
                <span
                  *ngIf="tooltipsVisible['getTopCopilotUsers']"
                  (click)="$event.stopPropagation()"
                  class="tooltip-content"
                  >{{ 'home.getTopCopilotUsersTooltip' | translate }}</span
                >
              </div>
            </span>
          </div>
          <div class="widget-content h-100">
            <div
              class="table-responsive"
              style="
                height: 90%;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
              "
            >
              <div class="d-flex justify-content-center" *ngIf="isLoading8">
                <div class="spinner-border" role="status">
                  <span class="sr-only">{{ 'home.loading' | translate }}</span>
                </div>
              </div>
              <table
                *ngIf="!isLoading8 && !chart8Empty"
                class="table table-hover"
              >
                <thead>
                  <tr>
                    <th>
                      <div class="th-content">
                        {{ 'home.user' | translate }}
                      </div>
                    </th>
                    <th>
                      <div class="th-content">
                        {{ 'home.interactions' | translate }}
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let user of getTopCopilotUsers">
                    <td>
                      <div class="d-flex align-center">
                        <p class="mb-0">{{ user.user || '' }}</p>
                      </div>
                    </td>
                    <td>
                      <span class="text-warning">{{ user.count || 0 }}</span>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div
                *ngIf="chart8Empty"
                id="noData"
                style="height: 4rem; display: grid; place-content: center"
              >
                {{ 'noData' | translate }}
              </div>
              <p
                *ngIf="!isLoading8 && !chart8Empty"
                class="font-13 text-center mt-2 mb-1 text-muted"
              >
                <a class="text-primary" routerLink="/home/informes/ia">{{
                  'home.clickHere' | translate
                }}</a>
                {{ 'home.toSeeFullList' | translate }}
              </p>
            </div>
          </div>
        </div>
      </div>

      <div class="chart-nine">
        <div class="widget widget-chart-two">
          <div
            class="widget-heading d-flex justify-content-between align-items-center"
          >
            <h5 class="">
              {{ 'home.topCopilotInteractionsByDepartment' | translate }}
            </h5>
            <span class="rounded-circle">
              <div
                data-tooltip="topCopilotInteractionsByDepartment"
                class="tooltip-container"
                (click)="toggleTooltip('topCopilotInteractionsByDepartment')"
              >
                <i
                  class="icon dashboard-tooltip-info"
                  style="font-size: 30px"
                ></i>
                <span
                  *ngIf="tooltipsVisible['topCopilotInteractionsByDepartment']"
                  (click)="$event.stopPropagation()"
                  class="tooltip-content bottom"
                  >{{
                    'home.topCopilotInteractionsByDepartmentTooltip' | translate
                  }}</span
                >
              </div>
            </span>
          </div>
          <div
            class="widget-content"
            style="min-height: 340px; padding: 0 !important"
          >
            <div class="center" style="min-height: 340px" *ngIf="isLoading9">
              <div class="spinner-border" role="status">
                <span class="sr-only">{{ 'home.loading' | translate }}</span>
              </div>
            </div>
            <div id="topCopilotInteractionsByDepartment" class=""></div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Main Body Ends -->
</div>
